import { EnumBase } from 'hay-core-react';
class TarefaAgendadaLogTipoExecucaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.tarefaagendadalog.tipoexecucao.automatico',
                'main.tarefaagendadalog.tipoexecucao.manual',
            ],
            'main.tarefaagendadalog.tipoexecucao.automatico'
        );
    }
}

const instance = new TarefaAgendadaLogTipoExecucaoEnum();
export default instance;
